(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["oh-featured"] && !Shopify.designMode) return;
  try {
    
(() => {
  const mount = (scope = document) => scope.querySelectorAll('[data-oh-featured]').forEach(section => {
    if(section.dataset.railReady)return;
    const rail=section.querySelector('[data-oh-featured-rail]'),nav=section.querySelector('[data-oh-featured-nav]');
    if(!rail||!nav)return;
    section.dataset.railReady='true';
    const buttons=[...nav.querySelectorAll('[data-oh-featured-step]')];
    let queued=false;
    const update=()=>{queued=false;const max=rail.scrollWidth-rail.clientWidth,position=Math.abs(rail.scrollLeft);nav.hidden=max<=1;buttons.forEach(button=>{button.disabled=Number(button.dataset.ohFeaturedStep)<0?position<=1:position>=max-1;});};
    const schedule=()=>{if(!queued){queued=true;requestAnimationFrame(update);}};
    buttons.forEach(button=>button.addEventListener('click',()=>{const direction=getComputedStyle(rail).direction==='rtl'?-1:1;rail.scrollBy({left:Number(button.dataset.ohFeaturedStep)*direction*rail.clientWidth*.75,behavior:'smooth'});}));
    rail.addEventListener('scroll',schedule,{passive:true});
    if('ResizeObserver' in window)new ResizeObserver(schedule).observe(rail);else window.addEventListener('resize',schedule,{passive:true});
    update();
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>mount());else mount();
  document.addEventListener('shopify:section:load',event=>mount(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oh-finder"]) return;
  try {
    
  (() => {
    const questions = ['room', 'piece', 'space', 'function', 'palette', 'material', 'budget', 'timeline'];
    const pieceRooms = { sofa: ['living-room'], seating: ['living-room', 'dining', 'study'], table: ['living-room', 'dining', 'study'], bed: ['bedroom'], bedside: ['bedroom'] };
    const palettePatterns = { light: /\b(white|cream|ivory|beige|oat|sand|natural)\b/i, warm: /\b(walnut|oak|brown|honey|cognac|tan|acacia|teak)\b/i, dark: /\b(black|charcoal|dark|espresso|gunmetal|navy)\b/i, color: /\b(green|sage|olive|blue|terracotta|rust)\b/i };
    const materialPatterns = { wood: /\b(wood|oak|walnut|pine|acacia|teak)\b/i, stone: /\b(marble|stone|travertine|granite|concrete|alabaster)\b/i, soft: /velvet|boucl|corduroy|chenille|leather|linen|upholster|fabric/i, woven: /\b(rattan|cane|wicker|woven|jute|sisal)\b/i, metal_glass: /\b(metal|steel|iron|brass|gold|glass)\b/i };
    const storagePattern = /storage|drawer|shelf|cabinet|cubby|bookcase|dresser/i;
    const feedCache = new Map();
    const fill = (text, values = {}) => String(text || '').replace(/\{(\w+)\}/g, (all, key) => values[key] ?? all);
    const cents = value => { if (value === null || value === undefined || value === '') return null; const n = Number(value); return Number.isFinite(n) && n >= 0 ? Math.round(n * 100) : null; };
    const budgetMaximum = answers => answers.budget === 'open' ? Infinity : Number(answers.budget) * 100;
    function sourceHandle(answers) { return answers.piece === 'lighting' ? 'lighting' : answers.piece === 'textiles' ? 'rugs-and-textiles' : answers.room; }
    function categoryPattern(answers) {
      const common = { sofa: /sofa|sectional|couch/i, seating: /chair|ottoman|bench/i, bed: /\bbed\b|\bbeds\b/i, bedside: /nightstand|bedside/i, storage: storagePattern, lighting: /lamp|sconce|pendant|chandelier|lighting/i, textiles: /rug|throw|blanket|curtain|pillow|cushion|bedding/i };
      if (answers.piece === 'table') return answers.room === 'dining' ? /dining.*table|table.*dining/i : answers.room === 'study' ? /desk/i : /(?:coffee|side|end|accent).*table/i;
      return common[answers.piece] || null;
    }
    function shortlist(products, answers) {
      const max = budgetMaximum(answers), category = categoryPattern(answers), palette = palettePatterns[answers.palette], material = materialPatterns[answers.material];
      if (!Array.isArray(products) || !Number.isFinite(max) && max !== Infinity) return [];
      return products.flatMap((product, index) => {
        if (!product || typeof product.handle !== 'string' || !product.handle || typeof product.title !== 'string') return [];
        const words = `${product.title} ${product.product_type || ''}`;
        if (category && !category.test(words)) return [];
        const variants = (Array.isArray(product.variants) ? product.variants : []).filter(v => v.available === true && /^\d+$/.test(String(v.id)) && cents(v.price) !== null && cents(v.price) <= max);
        variants.sort((a, b) => Number(Boolean(palette && palette.test(String(b.title)))) - Number(Boolean(palette && palette.test(String(a.title)))) || cents(a.price) - cents(b.price));
        const variant = variants[0]; if (!variant) return [];
        const variantWords = String(variant.title || '');
        const paletteWords = Object.values(palettePatterns).some(pattern => pattern.test(variantWords)) ? variantWords : words;
        const paletteCue = palette ? paletteWords.match(palette)?.[0] || '' : '';
        const materialCue = material ? words.match(material)?.[0] || '' : '';
        const storage = answers.function === 'storage' && storagePattern.test(words);
        const goalMatch = storage || answers.function === 'light' && /lamp|sconce|pendant|chandelier/i.test(words) || answers.function === 'comfort' && /sofa|chair|sectional|ottoman/i.test(words) || answers.function === 'gather' && /dining|sofa|sectional/i.test(words) || answers.function === 'finish' && /rug|throw|mirror|lamp|pillow/i.test(words);
        return [{ product, variant, price: cents(variant.price), compare: cents(variant.compare_at_price), paletteCue, materialCue, storage, score: Number(Boolean(paletteCue)) * 2 + Number(Boolean(materialCue)) * 2 + Number(Boolean(goalMatch)), index }];
      }).sort((a, b) => b.score - a.score || a.index - b.index).slice(0, 6);
    }
    function searchUrl(config, answers, origin) {
      const terms = { sofa: 'sofa', seating: 'chair', table: answers.room === 'dining' ? 'dining table' : answers.room === 'study' ? 'desk' : 'coffee table', bed: 'bed', bedside: 'nightstand', storage: 'storage', lighting: 'lamp', textiles: 'rug' };
      const url = new URL(config.search, origin);
      url.searchParams.set('q', terms[answers.piece] || config.collections[answers.room]?.title || answers.room);
      url.searchParams.set('type', 'product'); url.searchParams.set('options[prefix]', 'last'); url.searchParams.set('filter.v.availability', '1');
      if (Number.isFinite(budgetMaximum(answers))) url.searchParams.set('filter.v.price.lte', String(budgetMaximum(answers) / 100));
      return url.pathname + url.search;
    }
    const node = (tag, className, text) => { const el = document.createElement(tag); if (className) el.className = className; if (text !== undefined) el.textContent = text; return el; };
    function imageUrl(value, origin) { if (typeof value !== 'string' || !value.trim()) return ''; try { const url = new URL(value, origin); if (url.protocol !== 'https:') return ''; url.searchParams.set('width', '720'); return url.href; } catch { return ''; } }
    function productCard(match, config, answers) {
      const { product, variant } = match, money = value => new Intl.NumberFormat(config.locale || 'en-US', { style: 'currency', currency: config.currency || 'USD' }).format(value / 100);
      const li = node('li'), article = node('article', 'oh-finder__product'), link = node('a', 'oh-finder__product-link'), media = node('div', 'oh-finder__product-media');
      link.href = `${config.root.replace(/\/?$/, '/')}products/${encodeURIComponent(product.handle)}?variant=${encodeURIComponent(variant.id)}`;
      const src = imageUrl(variant.featured_image?.src || product.images?.[0]?.src || '', window.location.origin);
      if (src) { const image = node('img'); image.src = src; image.alt = ''; image.width = 720; image.height = 720; image.loading = 'lazy'; media.append(image); }
      link.append(media, node('h3', 'oh-finder__product-title', product.title));
      if (variant.title && variant.title !== 'Default Title') link.append(node('span', 'oh-finder__product-option', variant.title));
      const price = node('div', 'oh-finder__product-price'); price.append(node('span', '', money(match.price)));
      if (match.compare !== null && match.compare > match.price) price.append(node('s', '', money(match.compare)), node('small', '', config.text.sale));
      link.append(price); article.append(link);
      const reasons = node('ul', 'oh-finder__product-reasons');
      if (Number.isFinite(budgetMaximum(answers))) reasons.append(node('li', '', fill(config.text.budget, { amount: money(budgetMaximum(answers)) })));
      if (product.product_type) reasons.append(node('li', '', fill(config.text.category, { type: product.product_type })));
      if (match.paletteCue) reasons.append(node('li', '', fill(config.text.palette, { cue: match.paletteCue })));
      else if (match.materialCue) reasons.append(node('li', '', fill(config.text.material, { cue: match.materialCue })));
      else if (match.storage) reasons.append(node('li', '', config.text.storage));
      article.append(reasons);
      const save = node('button', 'oh-finder__save'); save.type = 'button'; save.hidden = true;
      save.setAttribute('data-oh-save', product.handle); save.setAttribute('aria-pressed', 'false'); save.setAttribute('aria-label', fill(config.text.save_piece, { title: product.title }));
      const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg'), path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      icon.setAttribute('viewBox', '0 0 24 24'); icon.setAttribute('aria-hidden', 'true'); icon.setAttribute('focusable', 'false'); path.setAttribute('d', 'M6.5 3.5h11v17l-5.5-3.8-5.5 3.8z'); icon.append(path); save.append(icon); article.append(save);
      li.append(article); return li;
    }
    async function fetchCollection(url, signal) {
      if (feedCache.has(url)) return feedCache.get(url);
      const response = await fetch(`${url.replace(/\/$/, '')}/products.json?limit=50`, { signal, credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Collection unavailable');
      const data = await response.json(); if (!Array.isArray(data.products)) throw new Error('Invalid collection response');
      const products = data.products.slice(0, 50); feedCache.set(url, products); return products;
    }
    function init(scope = document) {
      scope.querySelectorAll('[data-oh-finder]').forEach(root => {
        if (root.dataset.finderReady) return;
        let config; try { config = JSON.parse(root.querySelector('[data-oh-finder-config]').textContent); } catch { return; }
        const form = root.querySelector('[data-oh-finder-form]'), steps = [...form.querySelectorAll('[data-oh-finder-step]')], results = root.querySelector('[data-oh-finder-results]');
        if (steps.length !== questions.length) return;
        root.dataset.finderReady = 'true';
        const back = form.querySelector('[data-oh-finder-back]'), next = form.querySelector('[data-oh-finder-next]'), finish = form.querySelector('[data-oh-finder-finish]'), error = form.querySelector('[data-oh-finder-error]');
        let current = 0, brief = null, request = null, requestVersion = 0;
        const selected = key => form.querySelector(`input[name="${key}"]:checked`);
        const answers = () => Object.fromEntries(questions.map(key => [key, selected(key)?.value || '']));
        function syncPieces() {
          const room = selected('room')?.value;
          form.querySelectorAll('input[name="piece"]').forEach(input => {
            const allowed = !pieceRooms[input.value] || pieceRooms[input.value].includes(room);
            input.closest('[data-oh-finder-option]').hidden = !allowed; input.disabled = !allowed;
            if (!allowed) input.checked = false;
          });
        }
        function showStep(index, focus = true) {
          current = Math.max(0, Math.min(steps.length - 1, index)); syncPieces();
          steps.forEach((step, i) => { step.hidden = i !== current; }); back.hidden = current === 0; next.hidden = current === steps.length - 1; finish.hidden = current !== steps.length - 1;
          error.hidden = true; form.querySelector('progress').value = current + 1;
          form.querySelector('[data-oh-finder-progress]').textContent = fill(config.text.step, { current: current + 1, total: steps.length });
          if (focus) steps[current].querySelector('legend').focus({ preventScroll: true });
        }
        function validStep() {
          if (steps[current].querySelector('input:checked:not(:disabled)')) return true;
          error.textContent = config.text.required; error.hidden = false; steps[current].querySelector('input:not(:disabled)')?.focus(); return false;
        }
        function browseLinks(value) {
          const target = root.querySelector('[data-oh-finder-browse]'); target.replaceChildren();
          const collection = config.collections[sourceHandle(value)] || config.collections[value.room];
          if (collection?.url) {
            const url = new URL(collection.url, window.location.origin); url.searchParams.set('filter.v.availability', '1');
            if (Number.isFinite(budgetMaximum(value))) url.searchParams.set('filter.v.price.lte', String(budgetMaximum(value) / 100));
            const link = node('a', 'oh-button', fill(config.text.browse, { collection: collection.title })); link.href = url.pathname + url.search; target.append(link);
          }
          const search = node('a', 'oh-link', config.text.search); search.href = searchUrl(config, value, window.location.origin); target.append(search);
        }
        async function complete() {
          const value = answers();
          const missing = questions.findIndex(key => !value[key]); if (missing !== -1) { showStep(missing); validStep(); return; }
          request?.abort(); const version = ++requestVersion; brief = { version: 1, createdAt: new Date().toISOString(), answers: value };
          const summary = root.querySelector('[data-oh-finder-summary]'); summary.replaceChildren();
          questions.forEach((key, index) => { const entry = node('div'); entry.append(node('dt', '', steps[index].querySelector('legend').textContent), node('dd', '', selected(key).closest('label').querySelector('span').textContent)); summary.append(entry); });
          root.querySelector('[data-oh-finder-space-note]').textContent = config.text[value.space]; root.querySelector('[data-oh-finder-time-note]').textContent = config.text[value.timeline]; browseLinks(value);
          form.hidden = true; results.hidden = false; root.querySelector('[data-oh-finder-result-title]').focus({ preventScroll: true });
          results.scrollIntoView({ behavior: 'smooth', block: 'start' });
          root.querySelector('[data-oh-finder-save-status]').textContent = '';
          const status = root.querySelector('[data-oh-finder-status]'), grid = root.querySelector('[data-oh-finder-products]'); grid.replaceChildren(); status.textContent = config.text.loading; grid.setAttribute('aria-busy', 'true');
          const collection = config.collections[sourceHandle(value)];
          if (!collection?.url) { status.textContent = config.text.unavailable; grid.removeAttribute('aria-busy'); return; }
          request = new AbortController(); const timeout = setTimeout(() => request?.abort(), 8000);
          try {
            const products = await fetchCollection(collection.url, request.signal); if (version !== requestVersion) return;
            const matches = shortlist(products, value); grid.replaceChildren(...matches.map(match => productCard(match, config, value)));
            root.dispatchEvent(new CustomEvent('oh:recommendations-loaded', { bubbles: true }));
            status.textContent = matches.length ? fill(config.text.found, { count: matches.length }) : config.text.empty;
          } catch { if (version === requestVersion) status.textContent = config.text.unavailable; }
          finally { clearTimeout(timeout); if (version === requestVersion) grid.removeAttribute('aria-busy'); }
        }
        next.addEventListener('click', () => { if (validStep()) showStep(current + 1); }); back.addEventListener('click', () => showStep(current - 1));
        form.addEventListener('change', event => { if (event.target.name === 'room') syncPieces(); error.hidden = true; });
        form.addEventListener('submit', event => { event.preventDefault(); if (!validStep()) return; if (current < steps.length - 1) showStep(current + 1); else complete(); });
        root.querySelector('[data-oh-finder-edit]').addEventListener('click', () => { requestVersion++; request?.abort(); form.hidden = false; results.hidden = true; showStep(0); });
        root.querySelector('[data-oh-finder-save]').addEventListener('click', () => { if (!brief) return; const status = root.querySelector('[data-oh-finder-save-status]'); try { localStorage.setItem('oh:room-brief', JSON.stringify(brief)); status.textContent = config.text.saved; } catch { status.textContent = config.text.save_failed; } });
        showStep(0, false); form.hidden = false;
      });
    }
    window.OHFinder = Object.freeze({ shortlist, sourceHandle, searchUrl });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
    document.addEventListener('shopify:section:load', event => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oh-product"]) return;
  try {
    
  (() => {
    class OHProduct extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        const payload = this.querySelector('[data-oh-product-data]');
        this.form = this.querySelector('[data-oh-product-form]');
        this.select = this.querySelector('[data-oh-variant-select]');
        this.addButton = this.querySelector('[data-oh-product-add]');
        if (!payload || !this.form || !this.select || !this.addButton) return;
        try { this.data = JSON.parse(payload.textContent); } catch { return; }
        if (!Array.isArray(this.data.variants) || !this.data.variants.length) return;
        this.ready = true;
        this.abort = new AbortController();
        this.text = this.data.text;
        this.quantity = this.querySelector('[data-oh-quantity]');
        this.message = this.querySelector('[data-oh-pdp-message]');
        this.price = this.querySelector('[data-oh-pdp-price]');
        this.availability = this.querySelector('[data-oh-pdp-availability]');
        this.express = this.querySelector('[data-oh-pdp-express]');
        this.options = this.querySelector('[data-oh-options]');
        this.radios = [...this.querySelectorAll('[data-oh-option-index]')];
        this.dialog = this.querySelector('[data-oh-zoom]');
        this.galleryLink = this.querySelector('[data-oh-gallery-open]');
        this.sticky = this.querySelector('[data-oh-sticky-buy]');
        this.stickyButton = this.querySelector('[data-oh-sticky-submit]');
        this.stickyPrice = this.querySelector('[data-oh-sticky-price]');
        this.mediaIndex = 0;
        this.imageRequest = (this.imageRequest || 0) + 1;
        this.pendingMediaIndex = null;
        this.pendingImage = null;
        this.zoomRequest = (this.zoomRequest || 0) + 1;
        this.pendingZoomImage = null;
        this.gallerySwipe = null;
        this.swipeClick = null;
        this.busy = false;
        this.discountBusy = false;
        this.discountStatus = 'idle';
        this.discountButton = this.querySelector('[data-oh-apply-discount]');
        this.discountMessage = this.querySelector('[data-oh-discount-message]');
        this.discountFallback = this.querySelector('[data-oh-offer-fallback]');
        this.mainVisible = false;
        this.sectionVisible = true;
        const requestedVariant = new URL(location.href).searchParams.get('variant');
        this.reviewed = this.data.variants.length === 1 || this.data.hasOnlyDefaultVariant || this.data.variants.some(variant => String(variant.id) === requestedVariant);
        this.variant = this.data.variants.find(variant => String(variant.id) === String(this.select.value)) || this.data.variants[0];
        this.selection = [...this.variant.options];
        const initialImage = this.data.images.findIndex(item => String(item.id) === String(this.variant.imageId));
        if (initialImage >= 0) this.mediaIndex = initialImage;
        this.applyVariant(false);
        this.on(this, 'change', event => this.changeOption(event));
        this.on(this.form, 'submit', event => this.submitProduct(event));
        this.on(this, 'click', event => this.handleClick(event));
        this.on(document, 'DOMContentLoaded', () => this.setupDiscount());
        this.on(document, 'oh:discount-updated', event => { this.setupDiscount(false); this.receiveDiscountState(event.detail); });
        this.on(document, 'oh:cart-updated', () => this.setupDiscount());
        this.setupDiscount();
        this.on(this, 'keydown', event => {
          if (!this.dialog?.open || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.stepImage(event.key === 'ArrowRight' ? 1 : -1);
        });
        if (this.dialog) {
          this.on(this.dialog, 'close', () => {
            if (this.dialog.open) return;
            this.zoomRequest += 1;
            this.pendingZoomImage = null;
            this.syncSticky();
            this.zoomReturn?.focus({ preventScroll: true });
          });
          this.on(this.dialog, 'click', event => { if (event.target === this.dialog) this.dialog.close(); });
          const zoomImage = this.querySelector('[data-oh-zoom-image]');
          if (zoomImage) this.on(zoomImage, 'error', () => {
            const mainImage = this.galleryLink?.querySelector('img');
            const fallback = mainImage?.currentSrc || mainImage?.src;
            if (!fallback || zoomImage.src === fallback) return;
            this.zoomRequest += 1;
            this.pendingZoomImage = null;
            zoomImage.src = fallback;
          });
        }
        if (this.options) {
          this.options.hidden = false;
          this.querySelector('[data-oh-native-option]').hidden = true;
        }
        const controls = this.querySelector('[data-oh-gallery-controls]');
        if (controls) controls.hidden = false;
        this.setupGallerySwipe();
        this.setupSticky();
      }

      on(target, type, callback, options = {}) {
        target.addEventListener(type, callback, { ...options, signal: this.abort.signal });
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.imageRequest += 1;
        this.pendingMediaIndex = null;
        this.pendingImage = null;
        this.zoomRequest += 1;
        this.pendingZoomImage = null;
        this.gallerySwipe = null;
        this.swipeClick = null;
        this.buttonObserver?.disconnect();
        this.sectionObserver?.disconnect();
        this.overlayObserver?.disconnect();
        if (this.sticky) this.sticky.hidden = true;
        document.body.classList.toggle('oh-sticky-visible', !!document.querySelector('[data-oh-sticky-buy]:not([hidden])'));
        this.ready = false;
      }

      changeOption(event) {
        if (this.syncing) return;
        if (event.target === this.select) {
          const variant = this.data.variants.find(item => String(item.id) === String(this.select.value));
          if (!variant) return;
          this.selection = [...variant.options];
        } else if (event.target.matches('[data-oh-option-index]')) {
          this.selection[Number(event.target.dataset.ohOptionIndex)] = event.target.value;
        } else return;
        this.reviewed = true;
        this.variant = this.data.variants.find(item => item.options.every((value, index) => value === this.selection[index])) || null;
        this.applyVariant(true);
      }

      applyVariant(updateUrl) {
        const variant = this.variant;
        this.radios.forEach(input => {
          const value = this.selection[Number(input.dataset.ohOptionIndex)];
          if (input.tagName === 'SELECT') input.value = value;
          else input.checked = input.value === value;
        });
        this.querySelectorAll('[data-oh-option-label]').forEach(label => { label.textContent = this.selection[Number(label.dataset.ohOptionLabel)] || ''; });
        this.syncing = true;
        this.select.value = variant ? String(variant.id) : '';
        this.select.dispatchEvent(new Event('change', { bubbles: true }));
        this.syncing = false;
        this.renderPrice(variant);
        this.availability.textContent = variant ? (variant.available ? this.text.available : this.text.soldOut) : this.text.unavailable;
        this.availability.classList.toggle('is-unavailable', !variant?.available);
        if (this.quantity && variant) {
          const rule = variant.quantityRule || {};
          this.quantity.min = String(rule.min || 1);
          this.quantity.step = String(rule.increment || 1);
          if (rule.max != null) this.quantity.max = String(rule.max); else this.quantity.removeAttribute('max');
          const quantity = Number(this.quantity.value);
          if (!Number.isInteger(quantity) || quantity < Number(this.quantity.min) || (rule.max != null && quantity > rule.max) || (quantity - Number(this.quantity.min)) % Number(this.quantity.step)) this.quantity.value = this.quantity.min;
        }
        const imageIndex = variant && this.data.images.findIndex(item => String(item.id) === String(variant.imageId));
        if (typeof imageIndex === 'number' && imageIndex >= 0) this.selectImage(imageIndex);
        else if (variant && this.data.images.length) {
          const fallbackIndex = this.data.images.findIndex(item => String(item.id) === String(this.data.fallbackImageId));
          this.selectImage(fallbackIndex >= 0 ? fallbackIndex : 0);
        }
        else if (this.data.images.length && !this.galleryInitialized) this.selectImage(this.mediaIndex);
        if (updateUrl) {
          const url = new URL(location.href);
          if (variant) url.searchParams.set('variant', String(variant.id)); else url.searchParams.delete('variant');
          history.replaceState(history.state, '', url);
        }
        this.syncButtons();
      }

      renderPrice(variant) {
        if (!this.price) return;
        const onSale = !!variant && variant.compare > variant.price;
        this.price.classList.toggle('is-sale', onSale);
        const priceLabel = this.querySelector('[data-oh-price-label]');
        if (priceLabel) priceLabel.textContent = onSale ? this.text.salePrice : this.text.price;
        this.querySelectorAll('[data-oh-sale-badge]').forEach(badge => { badge.hidden = !onSale; });
        const current = document.createElement('span');
        current.className = 'oh-pdp__price-current';
        current.textContent = variant ? variant.priceText : this.text.unavailable;
        if (onSale) {
          const compare = document.createElement('del');
          compare.textContent = variant.compareText;
          compare.setAttribute('aria-label', `${this.text.regularPrice}: ${variant.compareText}`);
          current.setAttribute('aria-label', `${this.text.salePrice}: ${variant.priceText}`);
          const saving = document.createElement('span');
          saving.className = 'oh-pdp__saving';
          saving.textContent = this.text.saving.replace('__AMOUNT__', variant.saleSavingText);
          this.price.replaceChildren(current, compare, saving);
        } else this.price.replaceChildren(current);
        const offer = this.querySelector('[data-oh-pdp-offer]');
        if (offer) {
          offer.hidden = !variant?.available;
          const offerPrice = this.querySelector('[data-oh-offer-price]');
          const offerSaving = this.querySelector('[data-oh-offer-saving]');
          if (offerPrice) offerPrice.textContent = variant ? variant.offerPriceText : '';
          if (offerSaving) offerSaving.textContent = variant ? this.text.welcomeSaving.replace('__AMOUNT__', variant.offerSavingText) : '';
        }
        if (this.stickyPrice) this.stickyPrice.textContent = variant ? variant.priceText : '';
        this.syncDiscountControls();
      }

      setupDiscount(readState = true) {
        if (!this.discountButton) return;
        this.discountReady = typeof window.OHCart?.applyDiscount === 'function';
        this.discountButton.hidden = !this.discountReady;
        if (this.discountFallback) this.discountFallback.hidden = this.discountReady;
        const note = this.querySelector('[data-oh-offer-fallback-note]');
        if (note) note.hidden = this.discountReady;
        if (readState && window.OHCart?.discountState) this.receiveDiscountState(window.OHCart.discountState);
        this.syncDiscountControls();
      }

      receiveDiscountState(state) {
        if (!state || !this.discountButton) return;
        const code = String(this.data.welcomeCode || '').trim().toUpperCase();
        const related = String(state.code || '').trim().toUpperCase() === code;
        const codes = Array.isArray(state.codes) ? state.codes : state.cart?.discount_codes;
        const match = Array.isArray(codes) && codes.find(entry => String(entry.code || '').trim().toUpperCase() === code);
        let status;
        if (related && (state.outcomeUnknown || state.status === 'unknown')) status = 'unknown';
        else if (match?.applicable === true) status = 'applied';
        else if (related && state.status === 'pending' && state.pending === true) status = 'pending';
        else if (related && state.status === 'rejected') status = 'rejected';
        else if (related && state.status === 'removed') status = 'removed';
        else if (related && state.status === 'applied') status = 'unknown';
        else if (Array.isArray(codes)) status = this.discountStatus === 'applied' ? 'removed' : 'idle';
        else return;
        this.discountStatus = status;
        const messages = { applied: this.text.codeAppliedNote, pending: this.text.codePendingNote, rejected: this.text.codeRejectedNote, unknown: this.text.codeUnknown, removed: this.text.codeRemoved, idle: '' };
        const trustworthyMessage = status !== 'pending' && related && status === state.status && typeof state.message === 'string';
        if (this.discountMessage) this.discountMessage.textContent = trustworthyMessage ? state.message : messages[status];
        this.syncDiscountControls();
      }

      syncExpress() {
        if (this.express) this.express.hidden = !this.variant?.available || this.busy || this.discountBusy || this.discountStatus === 'pending';
      }

      syncDiscountControls() {
        this.syncExpress();
        if (!this.discountButton) return;
        const status = this.discountStatus || 'idle';
        this.discountButton.disabled = this.discountBusy || this.busy || !this.variant?.available || status === 'applied' || status === 'pending';
        this.discountButton.setAttribute('aria-busy', String(this.discountBusy));
        this.discountButton.setAttribute('data-state', status);
        this.discountButton.textContent = this.discountBusy ? this.text.applyingCode : status === 'applied' ? this.text.codeApplied : status === 'pending' ? this.text.codePending : this.text.applyCode;
        const bagLink = this.querySelector('[data-oh-code-bag]');
        if (bagLink) bagLink.hidden = !['unknown', 'rejected'].includes(status);
        if (this.discountFallback && this.variant) {
          const link = new URL(this.discountFallback.href, location.href);
          const destination = new URL(location.href);
          destination.searchParams.set('variant', String(this.variant.id));
          link.searchParams.set('redirect', `${destination.pathname}${destination.search}`);
          this.discountFallback.href = link.href;
        }
      }

      async applyWelcomeCode() {
        if (this.discountBusy || this.busy || !this.variant?.available || ['applied', 'pending'].includes(this.discountStatus)) return;
        if (typeof window.OHCart?.applyDiscount !== 'function') { this.setupDiscount(false); return; }
        this.discountBusy = true;
        if (this.discountMessage) this.discountMessage.textContent = '';
        this.syncButtons();
        try {
          const result = await window.OHCart.applyDiscount(this.data.welcomeCode);
          if (result) this.receiveDiscountState(result);
          else this.receiveDiscountState({ code: this.data.welcomeCode, status: 'unknown', outcomeUnknown: true });
        } catch {
          this.receiveDiscountState({ code: this.data.welcomeCode, status: 'unknown', outcomeUnknown: true });
        } finally {
          this.discountBusy = false;
          this.syncButtons();
        }
      }

      syncButtons() {
        const available = !!this.variant?.available;
        this.addButton.disabled = this.busy || this.discountBusy || !available;
        this.addButton.setAttribute('aria-busy', String(this.busy));
        this.addButton.textContent = this.busy ? this.text.adding : available ? this.text.add : this.variant ? this.text.soldOut : this.text.unavailable;
        if (this.stickyButton) {
          this.stickyButton.disabled = this.busy || this.discountBusy || !available;
          this.stickyButton.textContent = this.busy ? this.text.adding : !available ? this.text.soldOut : this.reviewed ? this.text.add : this.text.choose;
        }
        this.syncDiscountControls();
        this.syncSticky();
      }

      async submitProduct(event) {
        if (event.submitter && event.submitter !== this.addButton) return;
        if (!window.OHCart?.add) return;
        event.preventDefault();
        if (this.busy || this.discountBusy || !this.variant?.available || !this.form.reportValidity()) return;
        this.busy = true;
        this.message.textContent = '';
        this.syncButtons();
        this.radios.forEach(input => { input.disabled = true; });
        this.select.disabled = true;
        if (this.quantity) this.quantity.disabled = true;
        const quantity = Number(this.quantity?.value || 1);
        try {
          const result = await window.OHCart.add({ id: this.variant.id, quantity });
          this.message.textContent = result?.added ? (result.refreshFailed ? this.text.refreshFailed : this.text.added) : this.text.unknown;
        } catch (error) {
          this.message.textContent = error?.message || this.text.failed;
          if (!this.mainVisible) {
            this.message.setAttribute('tabindex', '-1');
            this.message.scrollIntoView({ behavior: document.documentElement?.dataset.ohMotionPaused === 'true' ? 'auto' : 'smooth', block: 'center' });
            this.message.focus({ preventScroll: true });
          }
        } finally {
          this.busy = false;
          this.radios.forEach(input => { input.disabled = false; });
          this.select.disabled = false;
          if (this.quantity) this.quantity.disabled = false;
          this.syncButtons();
        }
      }

      handleClick(event) {
        if (this.consumeGallerySwipeClick(event)) return;
        if (event.target.closest('[data-oh-apply-discount]')) { event.preventDefault(); this.applyWelcomeCode(); return; }
        const thumbnail = event.target.closest('[data-oh-image-id]');
        if (thumbnail && this.contains(thumbnail)) {
          const index = this.data.images.findIndex(item => String(item.id) === thumbnail.dataset.ohImageId);
          if (index >= 0) { event.preventDefault(); this.selectImage(index); }
          return;
        }
        const step = event.target.closest('[data-oh-gallery-step]');
        if (step) { event.preventDefault(); this.stepImage(Number(step.dataset.ohGalleryStep)); return; }
        if (event.target.closest('[data-oh-gallery-open], [data-oh-zoom-open]') && this.dialog && typeof this.dialog.showModal === 'function') {
          event.preventDefault();
          this.zoomReturn = document.activeElement;
          this.paintZoom();
          if (!this.dialog.open) this.dialog.showModal();
          this.syncSticky();
          return;
        }
        if (event.target.closest('[data-oh-sticky-submit]')) {
          if (!this.reviewed) {
            this.form.scrollIntoView({ behavior: document.documentElement?.dataset.ohMotionPaused === 'true' ? 'auto' : 'smooth', block: 'center' });
            (this.radios.find(input => input.tagName === 'SELECT' || input.checked) || this.select).focus({ preventScroll: true });
          } else this.form.requestSubmit(this.addButton);
        }
      }

      setupGallerySwipe() {
        if (!this.galleryLink || this.data.images.length < 2) return;
        this.on(this.galleryLink, 'pointerdown', event => {
          this.gallerySwipe = null;
          this.swipeClick = null;
          if (event.pointerType !== 'touch' || !event.isPrimary || this.dialog?.open || event.button > 0) return;
          if (event.target.closest('[data-oh-gallery-step], [data-oh-zoom-open], button, input, select, textarea')) return;
          this.gallerySwipe = { id: event.pointerId, x: event.clientX, y: event.clientY };
        }, { passive: true });
        this.on(document, 'pointerdown', event => {
          if (this.gallerySwipe && event.pointerType === 'touch' && event.pointerId !== this.gallerySwipe.id) this.gallerySwipe = null;
        }, { passive: true, capture: true });
        this.on(document, 'pointermove', event => {
          const swipe = this.gallerySwipe;
          if (!swipe || event.pointerId !== swipe.id) return;
          const dx = Math.abs(event.clientX - swipe.x);
          const dy = Math.abs(event.clientY - swipe.y);
          if (dy >= 12 && dy > dx) this.gallerySwipe = null;
        }, { passive: true, capture: true });
        this.on(document, 'pointerup', event => {
          const swipe = this.gallerySwipe;
          if (!swipe || event.pointerId !== swipe.id) return;
          this.gallerySwipe = null;
          if (event.pointerType !== 'touch' || !event.isPrimary) return;
          const dx = event.clientX - swipe.x;
          const dy = event.clientY - swipe.y;
          if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy) * 1.35) return;
          this.swipeClick = { id: swipe.id, until: Date.now() + 700 };
          this.stepImage(dx < 0 ? 1 : -1);
        }, { passive: true, capture: true });
        this.on(document, 'pointercancel', event => {
          if (this.gallerySwipe?.id === event.pointerId) this.gallerySwipe = null;
        }, { passive: true, capture: true });
        this.on(window, 'blur', () => { this.gallerySwipe = null; this.swipeClick = null; });
      }

      consumeGallerySwipeClick(event) {
        if (!this.swipeClick || event.target.closest('[data-oh-gallery-open]') !== this.galleryLink) return false;
        const swipe = this.swipeClick;
        this.swipeClick = null;
        if (Date.now() > swipe.until || event.detail === 0 || (event.pointerType && event.pointerType !== 'touch')) return false;
        if (typeof event.pointerId === 'number' && event.pointerId > 0 && event.pointerId !== swipe.id) return false;
        event.preventDefault();
        return true;
      }

      stepImage(direction) {
        if (this.data.images.length < 2) return;
        const from = this.pendingMediaIndex ?? this.mediaIndex;
        this.selectImage((from + direction + this.data.images.length) % this.data.images.length);
      }

      selectImage(index) {
        const media = this.data.images[index];
        if (!media || !this.galleryLink) return;
        if (this.pendingMediaIndex === index && this.pendingImage) return;
        const request = ++this.imageRequest;
        this.pendingMediaIndex = null;
        this.pendingImage = null;
        this.setImageMessage('');
        const oldImage = this.galleryLink.querySelector('img');
        const currentMatches = oldImage && new URL(oldImage.src, location.href).pathname === new URL(media.main, location.href).pathname;
        if (currentMatches) {
          this.commitImage(index);
          return;
        }
        const image = document.createElement('img');
        image.width = 1440;
        image.height = 1440;
        image.alt = media.alt || this.data.title;
        image.decoding = 'async';
        image.addEventListener('load', () => {
          if (request !== this.imageRequest || !this.ready || this.pendingImage !== image) return;
          image.classList.toggle('is-revealing', true);
          this.galleryLink.replaceChildren(image);
          this.commitImage(index);
        }, { once: true, signal: this.abort.signal });
        image.addEventListener('error', () => {
          if (request !== this.imageRequest || !this.ready || this.pendingImage !== image) return;
          this.pendingMediaIndex = null;
          this.pendingImage = null;
          this.setImageMessage(this.text.imageFailed);
        }, { once: true, signal: this.abort.signal });
        this.pendingMediaIndex = index;
        this.pendingImage = image;
        image.src = media.main;
      }

      commitImage(index) {
        const media = this.data.images[index];
        this.mediaIndex = index;
        this.pendingMediaIndex = null;
        this.pendingImage = null;
        this.galleryInitialized = true;
        this.galleryLink.href = media.full;
        this.querySelectorAll('[data-oh-image-id]').forEach(link => {
          if (String(media.id) === link.dataset.ohImageId) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current');
        });
        const count = `${index + 1} / ${this.data.images.length}`;
        this.querySelectorAll('[data-oh-image-count], [data-oh-zoom-count]').forEach(element => { element.textContent = count; });
        this.setImageMessage('');
        if (this.dialog?.open) this.paintZoom();
      }

      paintZoom() {
        const media = this.data.images[this.mediaIndex];
        const image = this.querySelector('[data-oh-zoom-image]');
        if (!media || !image) return;
        const request = ++this.zoomRequest;
        this.pendingZoomImage = null;
        image.alt = media.alt || this.data.title;
        const full = new URL(media.full, location.href).href;
        if (image.src === full && image.complete && image.naturalWidth > 0) return;
        const mainImage = this.galleryLink.querySelector('img');
        const fallback = mainImage?.currentSrc || mainImage?.src;
        if (fallback && image.src !== fallback) image.src = fallback;
        const candidate = document.createElement('img');
        candidate.decoding = 'async';
        candidate.addEventListener('load', () => {
          if (request !== this.zoomRequest || !this.ready || !this.dialog?.open || this.pendingZoomImage !== candidate) return;
          this.pendingZoomImage = null;
          image.src = full;
        }, { once: true, signal: this.abort.signal });
        candidate.addEventListener('error', () => {
          if (request !== this.zoomRequest || !this.ready || this.pendingZoomImage !== candidate) return;
          this.pendingZoomImage = null;
        }, { once: true, signal: this.abort.signal });
        this.pendingZoomImage = candidate;
        candidate.src = full;
      }

      setImageMessage(message) {
        const output = this.querySelector('[data-oh-image-status]');
        if (output) output.textContent = message;
      }

      setupSticky() {
        if (!this.sticky || !('IntersectionObserver' in window)) return;
        this.buttonObserver = new IntersectionObserver(entries => {
          this.mainVisible = entries[0].isIntersecting;
          if (this.mainVisible) this.reviewed = true;
          this.syncButtons();
        });
        this.buttonObserver.observe(this.addButton);
        this.sectionObserver = new IntersectionObserver(entries => { this.sectionVisible = entries[0].isIntersecting; this.syncSticky(); });
        this.sectionObserver.observe(this);
        this.overlayObserver = new MutationObserver(() => this.syncSticky());
        this.overlayObserver.observe(document.body, { attributes: true, attributeFilter: ['class', 'open', 'hidden'], subtree: true });
        this.on(window, 'resize', () => this.syncSticky());
        if (window.visualViewport) this.on(window.visualViewport, 'resize', () => this.syncSticky());
      }

      syncSticky() {
        if (!this.sticky || !this.buttonObserver) return;
        const body = document.body;
        const blocked = ['oh-overlay-open', 'oh-welcome-open', 'oh-keyboard-open', 'oh-nav-open'].some(name => body.classList.contains(name));
        const dialogOpen = !!document.querySelector('dialog[open]');
        const keyboard = window.visualViewport && window.innerHeight - window.visualViewport.height > 150;
        const visible = this.sectionVisible && !this.mainVisible && !blocked && !dialogOpen && !keyboard;
        if (this.sticky.hidden === visible) this.sticky.hidden = !visible;
        const anyVisible = !!document.querySelector('[data-oh-sticky-buy]:not([hidden])');
        if (body.classList.contains('oh-sticky-visible') !== anyVisible) body.classList.toggle('oh-sticky-visible', anyVisible);
      }
    }
    if (!customElements.get('oh-product')) customElements.define('oh-product', OHProduct);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oh-recommendations"]) return;
  try {
    
  (() => {
    class OHRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.started || !this.dataset.url) return;
        this.started = true;
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (!entries.some(entry => entry.isIntersecting)) return;
            this.observer.disconnect();
            this.loadRecommendations();
          }, { rootMargin: '400px 0px' });
          this.observer.observe(this);
        } else this.loadRecommendations();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.request?.abort();
        clearTimeout(this.timeout);
      }

      async loadRecommendations() {
        if (this.request) return;
        const url = new URL(this.dataset.url, location.href);
        if (url.origin !== location.origin) return;
        this.request = new AbortController();
        this.timeout = setTimeout(() => this.request.abort(), 8000);
        try {
          const response = await fetch(url, { signal: this.request.signal, headers: { Accept: 'text/html' } });
          if (!response.ok) return;
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const fresh = page.querySelector('[data-oh-recommendations-content]');
          const current = this.querySelector('[data-oh-recommendations-content]');
          if (!fresh || !current || fresh.hidden) return;
          current.replaceWith(fresh);
          this.dispatchEvent(new CustomEvent('oh:recommendations-loaded', { bubbles: true }));
        } catch {
        } finally {
          clearTimeout(this.timeout);
        }
      }
    }
    if (!customElements.get('oh-recommendations')) customElements.define('oh-recommendations', OHRecommendations);
  })();

  } catch(e) { console.error(e); }
})();
})();
